<section class="default-section">
  <article class="default-card">
    <div class="jumbotron mb-3">
      <h1 class="jumbotron-headline">Impressum</h1>
      <p class="jumbotron-lead">Auf dieser Seite erfahren Sie, wer für aSchwartz.de verantwortlich ist.</p>
    </div>

    <h1 class="paragraph-headline">Seitenbetreiber und Verantwortlicher</h1>
    <app-responsible-contact-details [showBusinessInfo]="true" [showMap]="true" [showTaxNumber]="true"></app-responsible-contact-details>
  </article>
</section>
